export const adlMapper = {
    feeding: "Feeding",
    bathing: "Bathing",
    toileting: "Toileting",
    grooming: "Grooming",
    ambulation: "Ambulation",
    transfer: "Transfer",
    bed_mobility: "Bed Mobility",
}